import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import {Form, Button, Row, Col, Card, Modal} from 'react-bootstrap'
import {toast} from "react-toastify";
import {authUrl, usernameOrLgPwError, copyRight} from "./data";
import './App.css';

function Login({setCookie}) {
    const [requestDto, setRequestDto] = useState({username: '', secPw: ''});
    let history = useHistory();
    const onAuth = (event) => {
        try {
            fetch(authUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestDto)
            }).then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(usernameOrLgPwError);
                }
            })
                .then((data) => {
                    if (data && data.jwt) {
                        var thirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
                        setCookie('subscriptionToken', data.jwt, {path: '/', expires: thirtyMinutes});
                        history.push('/subscription/tenant');
                    }
                }, (error) => {
                    if (error) {
                        toast.error(error.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                });
        } catch (e) {
            toast.error(e.message);
        }
        event.preventDefault();
    }

    const onUsernameChange = (e) => {
        if (e.target.value) {
            setRequestDto({...requestDto, username: e.target.value});
        } else {
            setRequestDto({...requestDto, username: ''});
        }
    }

    const onSecretChange = (e) => {
        if (e.target.value) {
            setRequestDto({...requestDto, secPw: e.target.value});
        } else {
            setRequestDto({...requestDto, secPw: ''});
        }
    }

    return (
        <div className="overflow-hidden">
            <Modal centered size='md' show={true}>
                <Card className="shadow loginFont ovalCorner">
                    <Card.Header className="text-center">
                        UGY Abonelik Giriş
                    </Card.Header>
                    <Card.Body className="ovalCorner">
                        <Form onSubmit={onAuth}>
                            <Form.Group as={Row}>
                                <Form.Label column>Kullanıcı Adı</Form.Label>
                                <Col lg={8}>
                                    <Form.Control type="username"
                                                  value={requestDto.username}
                                                  onChange={onUsernameChange}/>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Form.Label column>Şifre</Form.Label>
                                <Col lg={8}>
                                    <Form.Control type="password"
                                                  value={requestDto.secPw}
                                                  onChange={onSecretChange}/>
                                </Col>
                            </Form.Group>
                            <Row className="justify-content-lg-center pt-3">
                                <Button variant="primary" type="submit">
                                    Giriş
                                </Button>
                            </Row>
                        </Form>
                    </Card.Body>
                    <Card.Footer style={{"fontSize": 11, color: "#5178B1",position:"relative"}} className="text-center">
                        {copyRight}
                    </Card.Footer>
                </Card>
            </Modal>
        </div>
    )
}

export default Login;